var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-list-table',{attrs:{"can-write":_vm.auth.authManager.canWrite('clients'),"can-delete":_vm.auth.authManager.canRead('clients.delete')}})}
var staticRenderFns = []

export { render, staticRenderFns }